import {
  RESET,
  SET_LOGGED_IN,
  SET_PERMISSIONS,
  SET_USER
} from "../../utils/constants";

const initialState = () => ({});

const state = {
  ...initialState(),
  loggedInUser: {},
  isLoggedIn: false,
  permissions: []
};

const getters = {
  loggedInUser: state => state.loggedInUser,
  isLoggedIn: state => state.isLoggedIn,
  userHasPermission: state => slug => state.permissions.includes(slug)
};

const mutations = {
  [RESET](state) {
    Object.assign(state, initialState());
  },
  [SET_USER](state, payload) {
    state.loggedInUser = payload;
  },
  [SET_LOGGED_IN](state, payload) {
    state.isLoggedIn = payload;
  },
  [SET_PERMISSIONS](state, payload) {
    state.permissions = payload;
  }
};
const actions = {
  reset({ commit }) {
    commit(RESET);
  },
  me({ commit }) {
    axios("me")
      .then(response => {
        commit(SET_USER, response.data.data);
        commit(SET_LOGGED_IN, true);

        const permissions = [...state.loggedInUser.permissions].reduce(
          (prev, el) => {
            return prev.concat(el.slug);
          },
          []
        );

        commit(SET_PERMISSIONS, permissions);
      })
      .catch(() => {
        commit(SET_USER, {});
        commit(SET_LOGGED_IN, false);
        commit(SET_PERMISSIONS, []);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
